import { settleApiCall } from '../../../api/utils';
import { createFieldToEntityMap } from '../../../utils/common';
export const getLabels = async _ref => {
  let {
    labelsClient,
    items,
    populationLevel,
    cacheLabels
  } = _ref;
  const shouldPopulateLabels = populationLevel == null ? void 0 : populationLevel.labels;
  if (!shouldPopulateLabels) {
    return {
      data: [],
      hasError: false
    };
  }
  const someItemsHaveLabels = items.some(item => (item.labels || []).length > 0);
  if (!someItemsHaveLabels) {
    return {
      data: [],
      hasError: false
    };
  }
  let labelsResult = [];
  if (cacheLabels) {
    labelsResult = cacheLabels;
  } else {
    const labelsApiResponse = await settleApiCall(() => labelsClient.getBulk());
    if (labelsApiResponse.hasError) {
      return labelsApiResponse;
    }
    labelsResult = labelsApiResponse.data.data;
  }
  const labelsMap = createFieldToEntityMap(labelsResult, 'id');
  return {
    data: labelsResult,
    idsToEntityMap: labelsMap,
    hasError: false
  };
};
//# sourceMappingURL=getLabels.js.map